<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <Blocks :crop-type-id="cropTypeId" />
    </div>
</template>

<script>
import currentUserQuery from '@views/Blocks/Browse/queryCurrentUser.graphql';

import Blocks from '../Blocks/Browse.vue';

export default {
  name: 'BlocksContainer',
  props: ['cropTypeId'],
  components: {
    Blocks,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['grower', 'developer', 'admin', 'processor'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
